// extracted by mini-css-extract-plugin
export var bg = "style-module--bg--c7ae5";
export var swiperBtnNext = "style-module--swiper-btn-next--014e4";
export var swiperBtnPrev = "style-module--swiper-btn-prev--30ed2";
export var swiperButtons = "style-module--swiper-buttons--3f41f";
export var vid = "style-module--vid--9b649";
export var wrap = "style-module--wrap--e5c9b";